<div class="sw-cms-el-config-moorl-opening-hours">
    <sw-cms-mapping-field
        v-model:config="element.config.openingHours"
        value-types="string"
    >
        <moorl-opening-hours v-model:value="element.config.openingHours.value"/>
    </sw-cms-mapping-field>
    <sw-cms-mapping-field
        v-model:value="element.config.timeZone"
        value-types="string"
    >
        <mt-text-field
            :label="$tc('sw-cms.elements.moorl-opening-hours.label.timeZone')"
            v-model="element.config.timeZone.value"
        />
    </sw-cms-mapping-field>
</div>